export default [
    {
        id: 1,
        title: 'Belki Uyaniriz Bi Sahilde',
        image: 'https://i.scdn.co/image/ab67706c0000da84fa7732791ac2d2a5f68d8e9d',
        artist: 'Furkan Anter',
        description: 'Made by Furkan',
        src: 'https://cdn.freesound.org/previews/646/646486_1391542-lq.mp3',
        type:'album',
    },
    {
        id: 2,
        title: 'Fuji',
        image: 'https://i.scdn.co/image/ab67706c0000da845b9e677307e8e0f43ae6d25a',
        artist: 'Furkan Anter',
        description: 'Mountain',
        src: 'https://cdn.freesound.org/previews/646/646487_5674468-lq.mp3',
        type:'album',

    },
    {
        id: 3,
        title: 'Top 50 - Germany',
        image: 'https://charts-images.scdn.co/assets/locale_en/regional/daily/region_de_default.jpg',
        artist: 'Furkan Anter',
        description: 'Your Daily Update of the most popular songs in Germany',
        src: 'https://cdn.freesound.org/previews/646/646457_1648170-lq.mp3',
        type:'album',
    },
    {
        id: 4,
        title: 'Blues Classics',
        image: 'https://i.scdn.co/image/ab67706c0000da84bd86a6416b81fceeab89b5fe',
        artist: 'Furkan Anter',
        description: 'Nothing but the best',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-game-show-suspense-waiting-667.mp3',
        type:'album',
    },
    {
        id: 5,
        title: 'Sticker',
        image: 'https://i.scdn.co/image/ab67616d0000b27373e21d92fa8c70ce6aba72d0',
        artist: 'Furkan Anter',
        description: 'New Album',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
    {
        id: 6,
        title: 'wundebar',
        image: 'https://i.scdn.co/image/ab67706c0000da84555f4ba762bd781cb6952e79',
        artist: 'Furkan Anter',
        description: 'wonderfulllll',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
    {
        id: 7,
        title: 'Club Mix',
        image: 'https://i.scdn.co/image/ab67706c0000da84ba245fce151c35d8b4ba6b7b',
        artist: 'Furkan Anter',
        description: 'Made by Furkan',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
    {
        id: 8,
        title: '0xfa',
        image: 'https://i.scdn.co/image/ab67706c0000da843047fb7ba2bc211bceb1501a',
        artist: 'Furkan Anter',
        description: 'Cryptonite',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
    {
        id: 9,
        title: 'tr-barock',
        image: 'https://i.scdn.co/image/ab67706c0000da84ead93d2ccf375e31e6967378',
        artist: 'Furkan Anter',
        description: 'some Turkish legends',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
    {
        id: 10,
        title: 'ee nabiyim',
        image: 'https://i.scdn.co/image/ab67706c0000da842ca3d847328eb339d437a06d',
        artist: 'Furkan Anter',
        description: 'Made by Furkan',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
    {
        id: 11,
        title: 'NKVT',
        image: 'https://i.scdn.co/image/ab67706f0000000269e1714dd78cb7f064910182',
        artist: 'Furkan Anter',
        description: 'Türkiye\'nin en sıkı çalma listesi. Kapak: Khontkar',
        src: 'https://assets.mixkit.co/sfx/preview/mixkit-rain-and-thunder-storm-2390.mp3',
        type:'album',
    },
]